import { render, staticRenderFns } from "./JcdcErrorWrapper.vue?vue&type=template&id=4d507578"
import script from "./JcdcErrorWrapper.vue?vue&type=script&lang=ts"
export * from "./JcdcErrorWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports